import PlasmicHamdastBimehnamaWidget, {
  PlasmicHamdastBimehnamaWidget__ArgProps,
} from '.plasmic/plasmic/hamdast_bimehnama/PlasmicHamdastBimehnamaWidget';

import PlasmicHamdastViraWidget, { PlasmicHamdastViraWidget__ArgProps } from '.plasmic/plasmic/hamdast_vira/PlasmicHamdastViraWidget';

import PlasmicHamdastCywoc24Widget, {
  PlasmicHamdastCywoc24Widget__ArgProps,
} from '.plasmic/plasmic/hamdast_cywoc_24/PlasmicHamdastCywoc24Widget';

import PlasmicHamdastHamyarWidget, {
  PlasmicHamdastHamyarWidget__ArgProps,
} from '.plasmic/plasmic/hamdast_hamyar/PlasmicHamdastHamyarWidget';

import PlasmicHamdastCheraghWidget, {
  PlasmicHamdastCheraghWidget__ArgProps,
} from '.plasmic/plasmic/hamdast_cheragh/PlasmicHamdastCheraghWidget';

import PlasmicHamdastRahnamaWidget, {
  PlasmicHamdastRahnamaWidget__ArgProps,
} from '.plasmic/plasmic/hamdast_rahnama/PlasmicHamdastRahnamaWidget';

import PlasmicHamdastKhedmatWidget, {
  PlasmicHamdastKhedmatWidget__ArgProps,
} from '.plasmic/plasmic/hamdast_khedmat/PlasmicHamdastKhedmatWidget';
import Etebar, { Etebar__ArgProps } from '@/modules/hamdast/widgets/etebar';
import NoskheyarRenewal, { NoskheyarRenewal__ArgProps } from '@/modules/hamdast/widgets/noskheyarRenewal';

export const Components = {
  hhhzbbsffq0nlna: {
    component_id: '6-Wp84uf7hB4',
    project_id: 'k6ZwKcaHfkxemp7yqC1vbY',
    Component: PlasmicHamdastBimehnamaWidget,
    props_allowed: PlasmicHamdastBimehnamaWidget__ArgProps,
  },
  q2fgq5glc7cj06n: {
    component_id: 'yyVhLmBrt-LV',
    project_id: 'iTvVGxWkzCGxLfA4RjUaXF',
    Component: PlasmicHamdastViraWidget,
    props_allowed: PlasmicHamdastViraWidget__ArgProps,
  },
  aed80eahprc1qs0: {
    component_id: 'Y2Dk4BvdV4zZ',
    project_id: 'fc2TT88raN5pz7nywm4q4q',
    Component: PlasmicHamdastCywoc24Widget,
    props_allowed: PlasmicHamdastCywoc24Widget__ArgProps,
  },
  ad0b26pc5ni63nm: {
    component_id: 'SXuHQqEYBK76',
    project_id: 'g8Bqu3xcbG5xgWev5sVtns',
    Component: PlasmicHamdastHamyarWidget,
    props_allowed: PlasmicHamdastHamyarWidget__ArgProps,
  },
  o1maxe7isynnf3v: {
    component_id: 'ZjqBgretf8Lk',
    project_id: '4fjEYDyHsDvAphaYRHZchB',
    Component: PlasmicHamdastCheraghWidget,
    props_allowed: PlasmicHamdastCheraghWidget__ArgProps,
  },
  fb1sxun8iwn7due: {
    component_id: 'Q5Ep8mGNX1zK',
    project_id: '5MMYVxpXKV5JuJRaJPvqek',
    Component: PlasmicHamdastRahnamaWidget,
    props_allowed: PlasmicHamdastRahnamaWidget__ArgProps,
  },
  rrr3pbcc8ixyi8p: {
    component_id: 'M0Hes2jXBIMM',
    project_id: '666TdydnqTmUJpihDvjWrt',
    Component: PlasmicHamdastKhedmatWidget,
    props_allowed: PlasmicHamdastKhedmatWidget__ArgProps,
  },
  a0lgs56djmf09d2: {
    component_id: '',
    project_id: '',
    Component: Etebar,
    props_allowed: Etebar__ArgProps,
  },
  '1axz97y61jkt901': {
    component_id: '',
    project_id: '',
    Component: NoskheyarRenewal,
    props_allowed: NoskheyarRenewal__ArgProps,
  },
};
